/**
 *  @author singhai
 *  @date   2019-03-04 18:00:32
 *  @param {String}  content    展示内容
 *  @param {Number}  duration   延迟时间（毫秒）
 *  @param {String}  status     类型格式（控制class）
 *  @description 全局弹窗组件    this.$Alert.info({
 *                               content: "这是一条提示信息",
 *                                duration: 1000
 *                              });
 */

import Notification from "./notification.js";
let messageInstance;

function getMessageInstance() {
  messageInstance = messageInstance || Notification.newInstance();
  return messageInstance;
}

function notice({ duration = 1.5, content = "", status = "success" }) {
  let instance = getMessageInstance();

  instance.add({
    content: content,
    duration: duration,
    status: status
  });
}

export default {
  info(options) {
    return notice(options);
  }
};
